import { Navigate } from 'react-router-dom';
import CallPage from '../containers/call/CallPage';
import ChatInterface from '../containers/chat';
import MainLayout from '../layouts/MainLayout';
import { ROUTE_PATHS } from './constants';
import AuthGuard from './guards/authGuard';

const ProtectedRoutes = {
  path: '/portal',
  element: (
    <AuthGuard>
      <MainLayout />
    </AuthGuard>
  ),
  children: [
    {
      path: '',
      element: <ChatInterface />,
    },
    {
      path: ROUTE_PATHS.CALL,
      element: <CallPage />,
    },
    {
      path: '*',
      element: <Navigate to={ROUTE_PATHS.PORTAL} />,
    },
  ],
};

export default ProtectedRoutes;
